import { useQuery } from '@tanstack/react-query';
import { listTapsAtLocation } from '../api/client';

export function useTaps(locationId: string | null) {
  return useQuery({
    queryKey: ['taps', locationId],
    queryFn: () => listTapsAtLocation(locationId!, { includeKicked: true }),
    enabled: locationId != null,
    staleTime: 30_000,
  });
}
